import React, { useContext } from 'react';
import { Alert, Grid, TextField } from 'housecall-ui';

import HousecallCardCvcElement from 'components/Common/Inputs/TextFields/HousecallCardCvcElement';
import HousecallCardExpiryElement from 'components/Common/Inputs/TextFields/HousecallCardExpiryElement';
import HousecallCardNumberElement from 'components/Common/Inputs/TextFields/HousecallCardNumberElement';
import HousecallPostalCodeElement from 'components/Common/Inputs/TextFields/HousecallPostalCodeElement';

import { CreditCardFormContext, CreditCardFormDispatchContext } from './CreditCardFormProvider';

const CreditCardForm = () => {
  const values = useContext(CreditCardFormContext);
  const dispatch = useContext(CreditCardFormDispatchContext);

  return (
    <Grid container spacing={2} data-testid="credit-card-form">
      {values.generalStripeError && (
        <Grid item xs={12}>
          <Alert severity="error">{values.generalStripeError}</Alert>
        </Grid>
      )}
      <Grid item xs={12}>
        <TextField
          label="Name on card*"
          autoFocus
          fullWidth
          error={!!values.nameOnCardError}
          helperText={values.nameOnCardError}
          InputLabelProps={{ shrink: true }}
          data-testid="credit-card-form__name-on-card"
          onChange={(event) => {
            dispatch.setNameOnCard(event.target.value);
            dispatch.setNameOnCardError(undefined);
            dispatch.setGeneralStripeError(undefined);
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <HousecallCardNumberElement
          variant="filled"
          labelName="Card number*"
          errorMessage={values.cardNumberError}
          onChange={(data: stripe.elements.ElementChangeResponse) => {
            dispatch.setCardNumberError(data.error?.message);
            dispatch.setGeneralStripeError(undefined);
          }}
        />
      </Grid>
      <Grid item sm={4} xs={12}>
        <HousecallCardExpiryElement
          variant="filled"
          labelName="Exp date*"
          errorMessage={values.cardExpiryError}
          onChange={(data: stripe.elements.ElementChangeResponse) => {
            dispatch.setCardExpiryError(data.error?.message);
            dispatch.setGeneralStripeError(undefined);
          }}
        />
      </Grid>
      <Grid item sm={4} xs={12}>
        <HousecallCardCvcElement
          variant="filled"
          labelName="CVC*"
          errorMessage={values.cardCvcError}
          onChange={(data: stripe.elements.ElementChangeResponse) => {
            dispatch.setCardCvcError(data.error?.message);
            dispatch.setGeneralStripeError(undefined);
          }}
        />
      </Grid>
      <Grid item sm={4} xs={12}>
        <HousecallPostalCodeElement
          labelName="Postal code*"
          errorMessage={values.cardPostalCodeError}
          onChange={(data: stripe.elements.ElementChangeResponse) => {
            dispatch.setCardPostalCodeError(data.error?.message);
            dispatch.setGeneralStripeError(undefined);
          }}
        />
      </Grid>
    </Grid>
  );
};

export default CreditCardForm;
